export default __webpack_public_path__ + "static/media/blogr.01ac1abf.webp";